<div>
  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_日期" | translate }}
      <!-- Date -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="v4-layout-field-row justify-between">
          <host-range-picker
            class="flex-1 mr-5"
            [showFooter]="false"
            [size]="'large'"
            [disabledDate]="disabledDate"
            [(ngModel)]="dateRange"></host-range-picker>
          <div class="extra">
            {{
              (nights > 1 ? "component.sidebar.plural.total_nights" : "component.sidebar.singular.total_nights")
                | translate
                  : {
                      nights: nights
                    }
            }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar-hostex_price_html_相关房间" | translate }}
      <!-- Relevant Units -->
    </div>
    <div class="v4-layout-field">
      <div class="v4-layout-field-control">
        <div class="mb-[8px]" *ngFor="let unit of relevantUnits">
          <label nz-checkbox [(ngModel)]="unit.checked">
            {{ unit.title }}
          </label>
        </div>
      </div>
    </div>
  </div>

  <div class="v4-layout-form" [formGroup]="form">
    <div class="v4-layout-form-title">
      {{ "operate_sidebar_html_设置" | translate }}
      <!-- Settings -->
    </div>

    @for (control of controlOpts; track $index) {
      <div class="v4-layout-field">
        <div class="v4-layout-field-label w-[200px]">
          {{ control.label }}
        </div>
        <div class="v4-layout-field-control">
          <div class="v4-layout-field-row">
            @switch (control.type) {
              @case ("input") {
                <input
                  type="number"
                  nz-input
                  nzSize="large"
                  [placeholder]="form.get(control.name)?.value ? mixedPlaceholder : daysPlaceholder"
                  [formControlName]="control.name" />
              }
              @case ("checkbox") {
                <label
                  nz-checkbox
                  [formControlName]="control.name"
                  [nzIndeterminate]="form.get(control.name)?.value === 'Mixed'">
                  <!-- Enabled -->
                  {{ "property-property_detail-booking_setting_html_启用" | translate }}
                </label>
              }
            }
            <i
              class="ml-2"
              nz-icon
              nzType="exclamation-circle"
              nzTheme="outline"
              nz-tooltip
              nzTooltipOverlayClassName="w-[400px]"
              [nzTooltipTitle]="control.tooltip"></i>
          </div>
          <div class="v4-layout-field-extra">
            @for (platform of control.platforms; track platform) {
              <img class="w-[12px] mr-[2px]" [src]="(platform | thirdparty).icon" />
            }
          </div>
        </div>
      </div>
    }

    <div class="v4-layout-field">
      <nz-alert nzShowIcon [nzMessage]="'calendar-hostex_sidebar-rules_html_set_tip' | translate"></nz-alert>
    </div>
  </div>

  <footer class="bar-footer">
    <button nz-button nzSize="large" (click)="onClickCancel()">
      {{ "word.cancel" | translate }}
      <!-- 取消 -->
    </button>
    <button nz-button nzType="primary" nzSize="large" [nzLoading]="loading" (click)="onClickSave()">
      {{ "word.save" | translate }}
      <!-- 保存 -->
    </button>
  </footer>
</div>
